import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { creditCardInstallments } from "../../../../../constants";

export default function CreditCardInstallmentsSelect({ maxInstallments = 1, onChangeMaxInstallments = () => {}}) {
  return (
    <FormControl variant="outlined">
      <InputLabel>Limite de parcelas</InputLabel>
      <Select
        label="Limite de parcelas"
        value={maxInstallments}
        onChange={e => onChangeMaxInstallments(e.target.value)}
      >
        {creditCardInstallments.map(installment => {
          return (
            <MenuItem value={installment.value}>{installment.label}</MenuItem>
          )
        })}
      </Select>
    </FormControl>
  );
}
